import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import {
  SuperAdminLimitedLogsViewActions,
  SuperAdminLimitedOASystemNavigationActions,
} from '@/features/superAdmin/superAdminLimitedPermissionActions.js'

export const superAdminLogsManagementRoutes = [
  {
    path: 'logs',
    component: DummyRouter,
    meta: {
      permissionAnyActions: SuperAdminLimitedLogsViewActions,
    },
    children: [
      {
        path: '',
        component: () => import('./SuperAdminLogsView.vue'),
        meta: {
          permissionAnyActions: SuperAdminLimitedLogsViewActions,
        },
      },
    ],
  },
  {
    path: 'oa-system',
    component: () => import('./oaSystem/SuperAdminLogsViewOASystem.vue'),
    meta: {
      permissionAnyActions: SuperAdminLimitedOASystemNavigationActions,
    },
  },
]
